import { RouteObject } from 'react-router-dom'
import FundLayout from 'layout/fund/FundLayout'
import ErrorBug from 'components/errors/bugs'
import CashboxPage from './cashboxPage'
import CashboxInvitationsPage from './invitations'
import CreateCashboxPage from './create'
import CashboxMembersPage from './members'
import CashboxShareGroupPage from './shareGroup'
import CashboxDrawPage from './draw'
import CashboxSettingsPage from './settings'
import CashboxPayWinnersPage from './payWinners'
import CashboxGroupPayPage from './groupPay'
import CashboxManualCashoutPage from './manualCashout'
import CashboxClaimPage from './claim'
import CashboxBulletinsPage from './bulletins'
import CashboxPlansPage from './plans'
import CashboxSubscriptionPage from './plans/subscription'

/**
 * صندوق قرعه‌کشی routes.
 *
 * Static segments are declared before `:id` — react-router ranks them higher
 * anyway, but the explicit order keeps `/cashbox/create` from ever reading as
 * a cashbox whose id is "create".
 *
 * There is deliberately no join-by-link route here. A cashbox is not
 * self-service: the manager adds every member from `/cashbox/:id/members`, so
 * nothing in the PWA exposes `membership/request/`.
 */
export const cashboxRoutes: RouteObject[] = [
    {
        path: '/cashbox',
        element: <FundLayout helmet="صندوق قرعه‌کشی" />,
        errorElement: <ErrorBug />,
        children: [
            { index: false, path: 'create', element: <CreateCashboxPage /> },
            {
                index: false,
                path: 'invitations',
                element: <CashboxInvitationsPage />,
            },
            { index: false, path: ':id', element: <CashboxPage /> },
            {
                index: false,
                path: ':id/members',
                element: <CashboxMembersPage />,
            },
            {
                index: false,
                path: ':id/share-group',
                element: <CashboxShareGroupPage />,
            },
            {
                index: false,
                path: ':id/share-group/:groupId',
                element: <CashboxShareGroupPage />,
            },
            { index: false, path: ':id/draw', element: <CashboxDrawPage /> },
            {
                index: false,
                path: ':id/pay-winners',
                element: <CashboxPayWinnersPage />,
            },
            {
                index: false,
                path: ':id/group-pay',
                element: <CashboxGroupPayPage />,
            },
            {
                index: false,
                path: ':id/manual-cashout',
                element: <CashboxManualCashoutPage />,
            },
            { index: false, path: ':id/claim', element: <CashboxClaimPage /> },
            {
                index: false,
                path: ':id/bulletins',
                element: <CashboxBulletinsPage />,
            },
            {
                index: false,
                path: ':id/plans',
                element: <CashboxPlansPage />,
            },
            {
                index: false,
                path: ':id/plans/subscription',
                element: <CashboxSubscriptionPage />,
            },
            {
                index: false,
                path: ':id/settings',
                element: <CashboxSettingsPage />,
            },
        ],
    },
]
